import React, { useEffect, useState, useRef } from "react";
import { useRouter } from "next/router";
import MaskInput from "../mask-input";
import PasswordInput from "../common/PasswordInput";
import { showNetworkError } from "utils/network-util";
import contries from "../../data/countries.json";
import styled from "styled-components";
import useCommon from "contexts/common-context/common-context";
import ErrorHandler from "components/ErrorHnadler";
import useAuth from "contexts/authcontext";
import useCountry from "./useCountry";
import useOutside from "hooks/useOutside";
import PhoneNumberInput from "components/common/PhoneNumber.Input";

// ## =>

const PasswordLogin = ({ onSuccess, switchMode, baseInfo, loginFromQr }) => {
  const [selectedCountry, setSelectedCountry] = useState({
    name: "Iran, Islamic Republic of Persian Gulf",
    flag: "ir",
    code: "+98",
    code_ui: "98+",
  });
  const [showContries, setShowContries] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [password, setPassword] = useState("");
  const {
    countryCode,
    countryName,
    foundCountry,
    searchCountry,
    filteredContries,
    countryCodeHandler,
    updateSelectedCountryCode,
  } = useCountry();
  const router = useRouter();
  const { notify } = useCommon();
  const { login } = useAuth();
  let inputRef = useRef();
  const passwordInputRef = useRef();
  const countriesContainer = useRef();
  useOutside(countriesContainer, () => {
    setShowContries(false);
  });
  const passwordHandler = (value) => setPassword(value);

  useEffect(() => {
    if (baseInfo.phoneNumber) {
      setPhoneNumber(baseInfo.phoneNumber);
    }
    if (Object.keys(baseInfo.countryCode).length > 0) {
      setSelectedCountry(baseInfo.countryCode);
      updateSelectedCountryCode(baseInfo.countryCode);
    }
  }, []);

  useEffect(() => {
    switchMode(phoneNumber, selectedCountry);
  }, [phoneNumber, selectedCountry]);

  useEffect(() => {
    setSelectedCountry(foundCountry);
  }, [foundCountry]);

  // React.useEffect(() => {
  //   if (inputRef) {
  //     const handleFocus = () => {
  //       setIsFocused(true);
  //     };
  //     inputRef.addEventListener("focus", handleFocus, false);
  //     return () => {
  //       if (inputRef) inputRef.removeEventListener("focus", handleFocus);
  //     };
  //   }
  // }, [inputRef]);

  // React.useEffect(() => {
  //   if (inputRef) {
  //     const handleBlur = () => {
  //       setTimeout(function () {
  //         setIsFocused(false);
  //       }, 300);
  //     };
  //     inputRef.addEventListener("blur", handleBlur, false);
  //     return () => {
  //       if (inputRef) inputRef.removeEventListener("blur", handleBlur);
  //     };
  //   }
  // }, [inputRef]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Tab" && document.activeElement === inputRef.current) {
        event.preventDefault();
        passwordInputRef.current.focus();
      }
    };
    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const handlechange = (values) => {
    const { value } = values;
    setPhoneNumber(value);
  };

  const formSubmitHandler = (e) => {
    e.preventDefault();

    const phoneNumberWithContryCode =
      selectedCountry.code + phoneNumber.replace(/^0/g, "");

    login(
      phoneNumberWithContryCode,
      password,
      true,
      router.pathname,
      false,
      router.query.dest,
      true,
      loginFromQr,
    )
      .then((res) => {
        if (res) {
          if (router.query.dest === "/user/passwd") {
            router.push("/user/welcome");
          } else if (onSuccess) {
            onSuccess(phoneNumber, res.customer_created);
          } else {
            if (router.query.dest) {
              router.push(router.query.dest);
              return;
            }
            router.push("/user/welcome");
          }
        }
      })
      .catch((err) => {
        console.log(err);
        showNetworkError(err, router);
        notify(ErrorHandler(err));
      });
  };

  return (
    <LoginWithPassword className="container justify-content-center d-flex">
      <form
        className="d-flex flex-column align-items-center "
        onSubmit={formSubmitHandler}
      >
        {" "}
        <div className=" border border-2 rounded   px-0  justify-content-end  custom-input container d-flex  align-items-center mb-3 w-100">
          <PhoneNumberInput
            autoFocus
            value={phoneNumber}
            getInputRef={inputRef}
            setValue={handlechange}
            allowEmptyFormatting
            className="pe-3  pe-md-3 pe-xl-3 pe-lg-3"
            tabIndex={2}
            name="mobileNumber"
          />
          <div
            style={{ background: "#C4C4C4" }}
            className=" d-flex align-items-center  rounded-end  w-50  "
          >
            <div
              style={{ background: "#C4C4C4" }}
              className=" d-flex align-items-center  rounded-end  ms-0 w-25 py-1 w-100  "
            >
              <span
                className="d-flex justify-content-around align-items-center gap-0 gap-lg-1 mx-lg-2 px-1 align-items-center "
                style={{ cursor: "pointer" }}
              >
                <input
                  style={{ width: "56px" }}
                  maxLength={5}
                  dir="ltr"
                  value={`+${countryCode}`}
                  tabIndex={1}
                  className="form-control me-2 me-lg-0 "
                  onChange={(e) =>
                    countryCodeHandler(e.target.value.replace(/^\+/, ""))
                  }
                  onFocus={(e) => e.target.select()}
                />
                <img
                  style={{ width: "45px", padding: "5px" }}
                  src={
                    selectedCountry.code === "none"
                      ? "/images/unset.png"
                      : `/icons/flags/${selectedCountry.flag}.svg`
                  }
                  alt=""
                  className="me-0 "
                  onClick={() => setShowContries(!showContries)}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="w-100">
          <PasswordInput
            setPasswordHandler={passwordHandler}
            placeHolder="رمز عبور"
            // classNames="py-1"
            checkPassword={true}
            passwordInputRef={passwordInputRef}
            style={{
              border: "1px solid #dee2e6",
              padding: "10px 15px",
            }}
          />
        </div>
        <button
          disabled={
            !(phoneNumber && phoneNumber.length >= 10 && password.length > 0) ||
            selectedCountry.code === "none"
          }
          tabIndex={4}
          type="submit"
          className="btn btn-primary px-5 mt-4"
        >
          ورود
        </button>
      </form>
      {showContries && (
        <ul
          className=" custom-drop-down position-absolute px-0 mt-lg-2  shadow "
          ref={countriesContainer}
          style={{
            maxHeight: "150px",
            zIndex: "10",
            backgroundColor: "#f1f1f1",
          }}
        >
          <input
            dir="ltr"
            type="text"
            name=""
            id=""
            className="form-control text-center my-2 bg-transparent border-bottom "
            placeholder="search..."
            value={countryName}
            onChange={(e) => searchCountry(e.target.value)}
            onFocus={(e) => e.target.select()}
          />
          {countryName.length < 1 &&
            contries.map((country, index) => {
              return (
                <li
                  key={index}
                  value=""
                  className="d-flex justify-content-between p-2  mb-1 "
                  onClick={() => {
                    setSelectedCountry(country);
                    updateSelectedCountryCode(country);
                    setShowContries(false);
                    searchCountry("");
                  }}
                >
                  {" "}
                  <span>{country.code_ui}</span>
                  <span className="d-flex gap-2">
                    <span>{country.name}</span>
                    <img
                      style={{ width: "25px" }}
                      src={`/icons/flags/${country.flag}.svg`}
                      alt=""
                      className=""
                    />
                  </span>
                </li>
              );
            })}
          {countryName.length >= 1 &&
            filteredContries.map((country, index) => {
              return (
                <li
                  key={index}
                  value=""
                  className="d-flex justify-content-between p-2  mb-1 "
                  onClick={() => {
                    setSelectedCountry(country);
                    updateSelectedCountryCode(country);
                    setShowContries(false);
                    searchCountry("");
                  }}
                >
                  {" "}
                  <span>{country.code_ui}</span>
                  <span className="d-flex gap-2">
                    <span>{country.name}</span>
                    <img
                      style={{ width: "25px" }}
                      src={`/icons/flags/${country.flag}.svg`}
                      alt=""
                      className=""
                    />
                  </span>
                </li>
              );
            })}
        </ul>
      )}
    </LoginWithPassword>
  );
};

const LoginWithPassword = styled.div`
  .custom-drop-down {
    overflow-y: scroll !important;
    border-radius: 8px;
    left: 50%;
    transform: translateX(-50%);
    top: 100px;
    width: 85% !important;
  }

  /* width */
  .custom-drop-down::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  .custom-drop-down::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  /* Handle */
  .custom-drop-down::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 8px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .custom-drop-down li:hover {
    background: rgba(0, 112, 192, 0.4);
    cursor: pointer;
  }

  .btn:focus {
    outline: none;
    box-shadow: none;
  }

  .form-control::-ms-reveal {
    display: none;
  }

  .form-control {
    border: none;
  }
  .form-control:focus {
    outline: none;
    box-shadow: none;
    border: none;
  }

  .w-custom {
    width: 23px !important;
  }

  .custom-input {
    width: 100%;
  }

  @media (min-width: 1100px) {
    .custom-input {
      width: 100%;
    }
  }
  @media (min-width: 1400px) {
    .custom-input {
      width: 80%;
    }
  }
`;

export default PasswordLogin;
